"use client";

import React from "react";
import { Wheat, Droplets, Clock, Hand, Flame } from "lucide-react";
import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
const stages = [{
  id: 1,
  time: "March - May",
  title: "Spring Awakening",
  desc1: "Full cleanup and mulching.",
  desc2: "Irrigation system activation.",
  desc3: "Lawn aeration and seeding."
}, {
  id: 2,
  time: "June - August",
  title: "Summer Vitality",
  desc1: "Precision mowing and edging.",
  desc2: "Pest and weed management.",
  desc3: "Hydration monitoring."
}, {
  id: 3,
  time: "Sept - Oct",
  title: "Autumn Prep",
  desc1: "Leaf removal and cleanup.",
  desc2: "Hedge and tree pruning.",
  desc3: "Winterization of systems."
}, {
  id: 4,
  time: "Nov - Feb",
  title: "Winter Rest",
  desc1: "Hardscape design planning.",
  desc2: "Equipment maintenance.",
  desc3: "Dormant season pruning."
}, {
  id: 5,
  time: "Year Round",
  title: "Custom Care",
  desc1: "Fencing and patio builds.",
  desc2: "Power washing services.",
  desc3: "Commercial maintenance."
}];
const icons = [{
  stageId: 1,
  Icon: Droplets
}, {
  stageId: 2,
  Icon: Hand
}, {
  stageId: 3,
  Icon: Wheat
}, {
  stageId: 4,
  Icon: Clock
}, {
  stageId: 5,
  Icon: Flame
}];
export default function The48HourJourney() {
  return <section data-section-id="223204" id="seasonal-care-calendar" className="dark bg-background text-foreground relative overflow-hidden py-24 lg:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-primary/10 via-background to-background" />

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="mb-16 text-center md:mb-24">
          <h2 className="font-default text-4xl font-bold tracking-tight sm:text-5xl md:text-6xl text-foreground">
            Seasonal Care Calendar
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg text-muted-foreground font-default">
            Our Organic Precision approach ensures your landscape thrives through every season. Follow our meticulous year-round maintenance schedule for a pristine outdoor space.
          </p>
        </div>

        <ScrollArea className="w-full pb-8">
          <div className="relative flex min-w-max w-full justify-between px-4 sm:px-8">
            {}
            <div className="absolute left-0 right-0 top-[5rem] -z-10 h-px bg-border/50" />

            {stages.map((stage, i) => {
            const IconComponent = icons.find(icon => icon.stageId === stage.id)?.Icon || Wheat;
            return <div key={stage.id} data-index={i} className="group flex w-64 flex-col items-center px-4">
                  {}
                  <div className="mb-6 flex h-8 items-center justify-center">
                    <span className="font-mono text-xs tracking-widest text-muted-foreground transition-colors duration-300 group-hover:text-primary">
                      {stage.time}
                    </span>
                  </div>

                  {}
                  <div className="relative mb-8 flex size-16 items-center justify-center rounded-lg border border-border bg-card transition-all duration-500 group-hover:border-primary group-hover:shadow-lg group-hover:shadow-primary/20">
                    <div className="absolute inset-0 rounded-lg bg-primary/20 blur-md opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                    <IconComponent className="relative z-10 size-6 text-foreground transition-colors duration-500 group-hover:text-primary" strokeWidth={1.5} />
                  </div>

                  {}
                  <div className="text-center">
                    <h3 className="font-default mb-3 text-xl font-semibold tracking-wide text-foreground">
                      {stage.title}
                    </h3>
                    <div className="space-y-1">
                      <p className="text-sm text-muted-foreground transition-colors duration-300 group-hover:text-foreground font-default">
                        {stage.desc1}
                      </p>
                      <p className="text-sm text-muted-foreground transition-colors duration-300 group-hover:text-foreground font-default">
                        {stage.desc2}
                      </p>
                      <p className="text-sm text-muted-foreground transition-colors duration-300 group-hover:text-foreground font-default">
                        {stage.desc3}
                      </p>
                    </div>
                  </div>
                </div>;
          })}
          </div>
          <ScrollBar orientation="horizontal" className="hidden sm:flex" />
        </ScrollArea>
      </div>
    </section>;
}